/**
 * Синхронно с `StaffSPARoutePaths` в `backend/core/usecase/staff_spa_routes.go`
 * (порядок как в Go — для диффа и тестов).
 */
export const STAFF_SPA_ROUTE_PATHS = [
  '/',
  '/superadmin/dashboard',
  '/superadmin/platform-users',
  '/superadmin/clients-catalog',
  '/superadmin/users',
  '/superadmin/users/platform',
  '/superadmin/users/clients',
  '/superadmin/users/roles',
  '/superadmin/payments',
  '/tenant/dashboard',
  '/fitness/dashboard',
  '/staff/dashboard',
  '/organization',
  '/organization/settings',
  '/organization/branches',
  '/organization/services',
  '/subscription',
  '/services-types',
  '/services-list',
  '/services-spaces',
  '/equipment',
  '/qrcode',
  '/qrcode-settings',
  '/subscriptions',
  '/schedule',
  '/schedule-workhours',
  '/bookings',
  '/clients-bookings',
  '/payments',
  '/application',
  '/global-widget-theme',
  '/widget-embed-lab',
  '/clients',
  '/users',
  '/staff',
  '/sales-funnel',
  '/sales-funnel-settings',
  '/automation-sources',
  '/automation-incoming',
  '/incoming-requests',
  '/audit-log',
  '/audit-payments',
  '/yc-sync-summary',
  '/yc-sync-settings',
  '/yc-discover-branches',
  '/yc-sync-log',
  '/yc-sync-conflicts',
  '/yc-unmapped',
  '/pending-auth',
  '/docs',
  '/contact',
  '/feedback',
  '/payment-gateways',
  '/admin-tokens',
  '/settings',
  '/platform-plans',
  '/tariffs',
  '/billing',
  '/all-users',
  '/access-rbac',
  '/platform-organizations',
  '/platform-tenant-requests',
  '/fitness',
  '/platform-qrcode-config',
  '/tasks',
  '/assistant',
  '/superadmin/assistant',
  '/me'
] as const;

export type StaffSPARoutePath = (typeof STAFF_SPA_ROUTE_PATHS)[number];
